export const environment = {
  production: false,
  api: 'https://api.qa.tk.videolink.app',
  storage: 'https://cdn.qa.tk.videolink.app',
  cdn: 'https://content.tk.videolink.app/',
  adminUrl: 'https://admin.qa.tk.videolink.app/',
  wsServer: '',
}
